import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { useAuthGuard } from "../../useAuthGuard";

export const useAuthGuard = (token, redirectYes) => {
  const navigate = useNavigate();
  // useAuthGuard(localStorage.getItem("token") || null);

  useEffect(() => {
    if (token === null && redirectYes === false) {
      navigate("/");
    } else if (token !== null && redirectYes === true) {
      navigate("/dashboard");
    }
  }, [token ,navigate ,redirectYes]);
};
